import React from 'react';
import Carousel from 'react-bootstrap/Carousel'
import JackAndBabyVi from '../resources/images/JackAndBabyVi.png';
import JackAndCharlieApril11 from '../resources/images/CharlieJackDeckApril11.png';
import VirginiaJack from '../resources/images/VirginiaJack.png';
import './MainCarousel.js';

class MainCarousel extends React.Component{
	constructor(props){
		super(props)
		this.state ={
			firstLabel: "Jack And Baby Violet",
			firstCaption: "Jack was a caring grandfather to many children",
			secondLabel: "Jack and his brother Charlie Braun",
			secondCaption: "Jack and Charlies alwsy had an angle",
			thirdLabel: "Jack Loved to travel",
			thirdCaption: "Jack in Virginia"
		}
	}
	render(){
		return (
			<Carousel>
			  <Carousel.Item>
			    <img src={JackAndBabyVi} alt="Jack and baby Vi" />
			    <Carousel.Caption>
			      <h3> {this.state.firstLabel} </h3>
			      <p>{this.state.firstCaption}</p>
			    </Carousel.Caption>
			  </Carousel.Item>
			  <Carousel.Item>
			    <img src={JackAndCharlieApril11} alt="BJack and Charlie"/>
			    <Carousel.Caption>
			      <h3>{this.state.secondLabel}</h3>
			      <p>{this.state.secondCaption}</p>
			    </Carousel.Caption>
			  </Carousel.Item>
  			  <Carousel.Item>
			    <img src={VirginiaJack} alt="Jack in Virginia" />
			    <Carousel.Caption>
			      <h3>{this.state.thirdLabel}</h3>
			      <p>{this.state.thirdCaption}</p>
			    </Carousel.Caption>
			  </Carousel.Item>
			</Carousel>
		);
	}
}
export default MainCarousel;